// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes throb {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.18);
    opacity: 0.75;
  }
}
:host {
  display: block;
  -webkit-user-select: none;
          user-select: none;
  font-size: 0.875rem;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
:host:not(.widget) {
  backdrop-filter: blur(20px);
}

.split-container {
  display: grid;
  gap: var(--density-spacing, 1.5rem);
  padding: var(--density-padding, 1rem) 2rem 2rem 1.5rem;
  grid-template-columns: 140px 1fr;
  height: 100%;
  box-sizing: border-box;
}
.split-container .sidenav {
  display: flex;
  flex-direction: column;
  gap: var(--density-spacing, 1.5rem);
}
.split-container .main {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: calc(var(--density-spacing, 1rem) * 2);
  overflow-y: auto;
  min-height: 0;
  padding: 10px;
  padding-bottom: 30px;
}

.tab-title {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 500;
  opacity: 0.8;
}

.tab-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.tab-header .tab-title {
  margin: 0;
}

.tab-nav-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.tab-nav-container .tab-nav {
  padding: 0.5rem 0.75rem;
  justify-content: flex-start;
  text-align: left;
  border-radius: 8px;
  transition: background-color 0.15s ease;
}
.tab-nav-container .tab-nav mat-icon {
  margin-right: 0.5rem;
  font-size: 20px;
  width: 20px;
  height: 20px;
  opacity: 0.7;
}
.tab-nav-container .tab-nav span {
  font-size: 0.875rem;
}
.tab-nav-container .tab-nav:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.tab-nav-container .tab-nav.active {
  background-color: rgba(0, 0, 0, 0.1);
  font-weight: 500;
}
.tab-nav-container .tab-nav.active mat-icon {
  opacity: 1;
}

.profile-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.profile-section .profile-picture {
  height: 2.5rem;
  width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid currentColor;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  font-size: 1.25rem;
  font-weight: bold;
}
.profile-section .profile-info {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}
.profile-section .profile-info .username {
  font-weight: 600;
  font-size: 0.875rem;
}
.profile-section .profile-info .team {
  font-size: 0.75rem;
  opacity: 0.7;
}

.setting-section {
  display: flex;
  flex-direction: column;
  gap: var(--density-spacing, 1rem);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  font-size: 0.9375rem;
}
.section-header mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  opacity: 0.7;
}

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.toggle-row .toggle-label {
  font-size: 0.875rem;
  opacity: 0.85;
}

::ng-deep .primary-toggle {
  --mat-slide-toggle-selected-track-color: color-mix(in srgb, var(--preset-primary, #1976d2) 30%, transparent);
  --mat-slide-toggle-selected-hover-track-color: color-mix(in srgb, var(--preset-primary, #1976d2) 35%, transparent);
  --mat-slide-toggle-selected-focus-track-color: color-mix(in srgb, var(--preset-primary, #1976d2) 35%, transparent);
  --mat-slide-toggle-selected-pressed-track-color: color-mix(in srgb, var(--preset-primary, #1976d2) 35%, transparent);
  --mat-slide-toggle-unselected-hover-track-color: #616161;
  --mat-slide-toggle-unselected-focus-track-color: #616161;
  --mat-slide-toggle-unselected-pressed-track-color: #616161;
}

.theme-toggle-row {
  display: flex;
  gap: 0.5rem;
}
.theme-toggle-row button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  transition: all 0.15s ease;
}
.theme-toggle-row button.active {
  background-color: var(--primary-color, #1976d2);
  color: white;
  border-color: var(--primary-color, #1976d2);
}
.theme-toggle-row button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.background-type-toggle {
  display: flex;
  gap: 0.5rem;
}
.background-type-toggle button {
  flex: 1;
  padding: 0.5rem 1rem;
  border-radius: 6px;
}
.background-type-toggle button.active {
  background-color: rgba(0, 0, 0, 0.1);
}

.bg-preview-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.bg-preview-container .bg-preview {
  position: relative;
  width: 100px;
  height: 70px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  border: 2px solid transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.bg-preview-container .bg-preview:hover {
  border-color: rgba(0, 0, 0, 0.3);
}
.bg-preview-container .bg-preview.selected {
  border-color: var(--primary-color, #1976d2);
}
.bg-preview-container .bg-preview.empty {
  background-color: rgba(0, 0, 0, 0.08);
  border: 2px dashed rgba(0, 0, 0, 0.2);
}
.bg-preview-container .bg-preview.empty:hover {
  background-color: rgba(0, 0, 0, 0.12);
  border-color: rgba(0, 0, 0, 0.3);
}
.bg-preview-container .bg-preview.empty .add-icon {
  color: rgba(0, 0, 0, 0.4);
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.bg-preview-container .bg-preview .check-icon {
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}
.bg-preview-container .bg-preview .replace-btn {
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  opacity: 0;
  cursor: pointer;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}
.bg-preview-container .bg-preview .replace-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}
.bg-preview-container .bg-preview .replace-btn mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: white;
  text-shadow: none;
}
.bg-preview-container .bg-preview:hover .replace-btn {
  opacity: 1;
}

.color-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 40px);
  gap: 0.5rem;
}

.color-swatch {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 2px solid transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}
.color-swatch:hover {
  transform: scale(1.1);
}
.color-swatch.selected {
  border-color: white;
  box-shadow: 0 0 0 2px var(--primary-color, #1976d2);
}
.color-swatch mat-icon {
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  font-size: 18px;
}

.custom-color-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.5rem;
}
.custom-color-row span {
  font-size: 0.875rem;
  opacity: 0.8;
}
.custom-color-row .color-picker {
  width: 40px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.chart-select {
  width: 100%;
}

.system-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0;
}
.info-row .info-label {
  font-size: 0.8125rem;
  opacity: 0.7;
}
.info-row .info-value {
  font-size: 0.875rem;
  font-weight: 500;
  font-family: monospace;
}

.trust-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.trust-section .trust-description {
  margin: 0;
  font-size: 0.8125rem;
  opacity: 0.8;
  line-height: 1.5;
}
.trust-section button {
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
}
.trust-section button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.trust-status {
  padding: 1rem;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}
.trust-status mat-progress-bar {
  margin-bottom: 0.5rem;
}
.trust-status p {
  margin: 0;
  font-size: 0.875rem;
  opacity: 0.8;
}

:host-context(.dark) .system-info {
  background: rgba(255, 255, 255, 0.03);
}
:host-context(.dark) .trust-status {
  background: rgba(255, 255, 255, 0.05);
}

.presets-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.presets-grid .preset-btn {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.8125rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.presets-grid .preset-btn .preset-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--preset-accent, #2aa198);
}
.presets-grid .preset-btn.active {
  background-color: rgba(0, 0, 0, 0.1);
  border-color: var(--preset-accent, #2aa198);
  border-width: 2px;
}

.section-header .clear-preset-btn {
  margin-left: auto;
  font-size: 0.75rem;
  min-width: auto;
  padding: 0 0.5rem;
  line-height: 1.5;
}
.section-header .size-value,
.section-header .custom-indicator {
  margin-left: auto;
  font-size: 0.875rem;
  font-weight: 500;
  opacity: 0.8;
}
.section-header .custom-indicator {
  color: var(--primary-color, #2aa198);
  font-size: 0.75rem;
  padding: 0.125rem 0.5rem;
  background: rgba(42, 161, 152, 0.1);
  border-radius: 4px;
}

.color-picker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.75rem;
}

.color-picker-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.color-picker-item label {
  font-size: 0.75rem;
  opacity: 0.7;
}
.color-picker-item .picker-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.color-picker-item .picker-row .color-picker {
  width: 32px;
  height: 32px;
  padding: 0;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  cursor: pointer;
  background: none;
}
.color-picker-item .picker-row .color-picker::-webkit-color-swatch-wrapper {
  padding: 2px;
}
.color-picker-item .picker-row .color-picker::-webkit-color-swatch {
  border-radius: 4px;
  border: none;
}
.color-picker-item .picker-row .color-hex-input {
  flex: 1;
  min-width: 0;
  padding: 0.375rem 0.5rem;
  font-family: monospace;
  font-size: 0.8rem;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.03);
  text-transform: uppercase;
}
.color-picker-item .picker-row .color-hex-input:focus {
  outline: none;
  border-color: var(--primary-color, #2aa198);
}

.slider-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.slider-row .slider-label {
  font-size: 0.75rem;
  opacity: 0.6;
  -webkit-user-select: none;
          user-select: none;
}
.slider-row .slider-label.large {
  font-size: 1.25rem;
}
.slider-row .slider {
  flex: 1;
  height: 4px;
  -webkit-appearance: none;
  appearance: none;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  cursor: pointer;
}
.slider-row .slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: var(--primary-color, #2aa198);
  border-radius: 50%;
  cursor: pointer;
  -webkit-transition: transform 0.15s ease;
  transition: transform 0.15s ease;
}
.slider-row .slider::-webkit-slider-thumb:hover {
  transform: scale(1.1);
}
.slider-row .slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: var(--primary-color, #2aa198);
  border: none;
  border-radius: 50%;
  cursor: pointer;
}
.slider-row .slider:focus {
  outline: none;
}

.transparency-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.transparency-row label {
  min-width: 60px;
  font-size: 0.875rem;
  opacity: 0.8;
}
.transparency-row .slider {
  flex: 1;
  height: 4px;
  -webkit-appearance: none;
  appearance: none;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  cursor: pointer;
}
.transparency-row .slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: var(--primary-color, #2aa198);
  border-radius: 50%;
  cursor: pointer;
  -webkit-transition: transform 0.15s ease;
  transition: transform 0.15s ease;
}
.transparency-row .slider::-webkit-slider-thumb:hover {
  transform: scale(1.1);
}
.transparency-row .slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: var(--primary-color, #2aa198);
  border: none;
  border-radius: 50%;
  cursor: pointer;
}
.transparency-row .slider:focus {
  outline: none;
}
.transparency-row .opacity-value {
  min-width: 45px;
  text-align: right;
  font-size: 0.875rem;
  opacity: 0.8;
  font-variant-numeric: tabular-nums;
}

.density-toggle-row {
  display: flex;
  gap: 0.5rem;
}
.density-toggle-row button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  transition: all 0.15s ease;
}
.density-toggle-row button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.density-toggle-row button.active {
  background-color: var(--primary-color, #1976d2);
  color: white;
  border-color: var(--primary-color, #1976d2);
}

.position-toggle-row {
  display: flex;
  gap: 0.5rem;
}
.position-toggle-row button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  transition: all 0.15s ease;
}
.position-toggle-row button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.position-toggle-row button.active {
  background-color: var(--primary-color, #1976d2);
  color: white;
  border-color: var(--primary-color, #1976d2);
}

.layout-toggle-row {
  display: flex;
  gap: 0.5rem;
}
.layout-toggle-row button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  transition: all 0.15s ease;
}
.layout-toggle-row button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.layout-toggle-row button.active {
  background-color: var(--primary-color, #1976d2);
  color: white;
  border-color: var(--primary-color, #1976d2);
}

.width-toggle-row {
  display: flex;
  gap: 0.5rem;
}
.width-toggle-row button {
  flex: 1;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8125rem;
  transition: all 0.15s ease;
}
.width-toggle-row button.active {
  background-color: var(--primary-color, #1976d2);
  color: white;
  border-color: var(--primary-color, #1976d2);
}

.setup-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  font-size: 0.875rem;
  opacity: 0.7;
}

.setup-checklist {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.setup-item {
  padding: 1rem;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.03);
  border: 2px solid transparent;
  transition: all 0.2s ease;
}
.setup-item.complete {
  border-color: rgba(76, 175, 80, 0.3);
  background: rgba(76, 175, 80, 0.05);
}
.setup-item.complete .status-icon {
  color: #4caf50;
}
.setup-item.pending {
  border-color: rgba(255, 152, 0, 0.3);
}
.setup-item.pending .status-icon {
  color: rgba(0, 0, 0, 0.3);
}
.setup-item.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.setup-item.disabled .status-icon {
  color: rgba(0, 0, 0, 0.2);
}

.setup-item-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.setup-item-header .status-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.setup-item-header .setup-item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}
.setup-item-header .setup-item-info .setup-item-title {
  font-weight: 500;
  font-size: 0.9375rem;
}
.setup-item-header .setup-item-info .setup-item-status {
  font-size: 0.8125rem;
  opacity: 0.7;
}
.setup-item-header .setup-action-btn {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 0.8125rem;
}
.setup-item-header .setup-action-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.setup-item-header .setup-action-btn.secondary {
  opacity: 0.7;
}
.setup-item-header .setup-action-btn.warn {
  color: #f44336;
  border-color: #f44336;
}
.setup-item-header .done-icon {
  color: #4caf50;
  opacity: 0.7;
}

.setup-item-progress {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.setup-item-progress mat-progress-bar {
  margin-bottom: 0.5rem;
}
.setup-item-progress .progress-text {
  font-size: 0.8125rem;
  opacity: 0.7;
}

.setup-item-auth-code {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.setup-item-auth-code .auth-instructions {
  font-size: 0.8125rem;
  opacity: 0.7;
  margin: 0 0 0.75rem 0;
}
.setup-item-auth-code .auth-code-field {
  width: 100%;
}
.setup-item-auth-code .auth-code-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  margin-top: 0.25rem;
}
.setup-item-auth-code .auth-code-actions {
  margin-top: 0.75rem;
  display: flex;
  gap: 0.5rem;
}
.setup-item-auth-code .auth-code-actions button {
  min-width: 120px;
}
.setup-item-auth-code .auth-code-actions button mat-spinner {
  display: inline-block;
}

.setup-item-error {
  margin-top: 0.75rem;
  padding: 0.5rem 0.75rem;
  background: rgba(244, 67, 54, 0.1);
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #f44336;
  font-size: 0.8125rem;
}
.setup-item-error mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.setup-complete-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1.75rem 1.5rem;
  margin-top: 1rem;
  background: rgba(76, 175, 80, 0.1);
  border-radius: 12px;
  animation: fadeSlideIn 0.35s ease-out;
}
.setup-complete-message .setup-complete-celebration {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #4caf50;
}
.setup-complete-message .setup-complete-celebration mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
}
.setup-complete-message .setup-complete-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #4caf50;
}
.setup-complete-message .setup-complete-subtitle {
  font-size: 0.8125rem;
  opacity: 0.75;
  margin-bottom: 0.5rem;
}
.setup-complete-message .setup-complete-cta {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.9375rem;
  font-weight: 500;
  letter-spacing: 0.02em;
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.backend-cards {
  display: flex;
  gap: 0.75rem;
  margin-top: 0.75rem;
  flex-wrap: wrap;
}

.backend-card {
  flex: 1;
  min-width: 140px;
  max-width: 200px;
  padding: 0.875rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: rgba(0, 0, 0, 0.02);
}
.backend-card:hover:not(.configured) {
  border-color: var(--primary-color, #2aa198);
  background: rgba(0, 0, 0, 0.04);
}
.backend-card.is-selected:not(.configured) {
  border-color: var(--primary-color, #2aa198);
  background: rgba(42, 161, 152, 0.08);
}
.backend-card.configured {
  border-color: #4caf50;
  background: rgba(76, 175, 80, 0.08);
  cursor: pointer;
}
.backend-card.configured.is-selected {
  border-color: var(--primary-color, #2aa198);
  background: rgba(42, 161, 152, 0.08);
}
.backend-card .backend-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem;
}
.backend-card .backend-name {
  font-weight: 500;
  font-size: 0.9375rem;
}
.backend-card .configured-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #4caf50;
}
.backend-card .not-installed-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #ff9800;
}
.backend-card .backend-desc {
  font-size: 0.75rem;
  opacity: 0.6;
}
.backend-card.not-installed {
  border-color: rgba(255, 152, 0, 0.3);
  background: rgba(255, 152, 0, 0.05);
}
.backend-card.coming-soon {
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
}
.backend-card.coming-soon .backend-card-header {
  justify-content: space-between;
}

.backend-config {
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}
.backend-config .config-instructions {
  margin: 0 0 0.75rem 0;
  font-size: 0.8125rem;
  opacity: 0.8;
}
.backend-config .config-instructions.config-instructions-ok {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  opacity: 1;
}
.backend-config .config-instructions.config-instructions-ok .configured-inline-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #4caf50;
}
.backend-config .config-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
.backend-config .config-actions:last-child {
  margin-bottom: 0;
}
.backend-config .install-command {
  font-family: "Fira Code", "Consolas", monospace;
  font-size: 0.8125rem;
  background: rgba(0, 0, 0, 0.08);
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  -webkit-user-select: all;
          user-select: all;
}
.backend-config .api-key-field,
.backend-config .auth-code-field {
  width: 100%;
  margin-bottom: 1.25rem;
}
.backend-config .api-key-field .field-action-btn,
.backend-config .auth-code-field .field-action-btn {
  opacity: 0.7;
  transition: opacity 0.15s ease;
}
.backend-config .api-key-field .field-action-btn:hover,
.backend-config .auth-code-field .field-action-btn:hover {
  opacity: 1;
}
.backend-config .api-key-field .field-action-btn.warn,
.backend-config .auth-code-field .field-action-btn.warn {
  color: #f44336;
}
.backend-config .api-key-field .field-action-btn.field-action-btn-throb,
.backend-config .auth-code-field .field-action-btn.field-action-btn-throb {
  opacity: 1;
  animation: throb 1.4s ease-in-out infinite;
}
.backend-config .api-key-field .field-action-btn.field-action-btn-throb mat-icon,
.backend-config .auth-code-field .field-action-btn.field-action-btn-throb mat-icon {
  color: var(--mat-sys-primary, #3f51b5);
}
.backend-config .api-key-field .hint-success,
.backend-config .auth-code-field .hint-success {
  color: #4caf50 !important;
}
.backend-config .model-select-field {
  width: 100%;
  margin-bottom: 0.75rem;
}

.add-provider {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.device-auth-flow {
  margin-top: 0.5rem;
}

.device-auth-info {
  background: var(--card-bg, rgba(0, 0, 0, 0.05));
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));
  border-radius: 8px;
  padding: 1rem;
  margin: 0.75rem 0;
}
.device-auth-info .device-url-row,
.device-auth-info .device-code-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
.device-auth-info .device-url-row:last-of-type,
.device-auth-info .device-code-row:last-of-type {
  margin-bottom: 0;
}
.device-auth-info .device-url-row .device-label,
.device-auth-info .device-code-row .device-label {
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
  font-size: 0.8rem;
  min-width: 40px;
}
.device-auth-info .device-url-row .device-url,
.device-auth-info .device-code-row .device-url {
  color: var(--link-color, #2196f3);
  font-size: 0.875rem;
  text-decoration: none;
  word-break: break-all;
}
.device-auth-info .device-url-row .device-url:hover,
.device-auth-info .device-code-row .device-url:hover {
  text-decoration: underline;
}
.device-auth-info .device-url-row .device-code,
.device-auth-info .device-code-row .device-code {
  font-family: "Fira Code", "Consolas", monospace;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--primary-color, #1976d2);
  letter-spacing: 0.1em;
  background: var(--code-bg, rgba(0, 0, 0, 0.08));
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
}
.device-auth-info .device-url-row button,
.device-auth-info .device-code-row button {
  flex-shrink: 0;
}
.device-auth-info .device-note {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin: 1rem 0 0 0;
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
  font-size: 0.8rem;
  line-height: 1.4;
}
.device-auth-info .device-note mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 2px;
  opacity: 0.7;
}

.labs-subtitle {
  margin: 0 0 1.5rem 0;
  font-size: 0.8125rem;
  opacity: 0.6;
  line-height: 1.5;
}

.labs-section-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.45;
  margin: 1.5rem 0 0.75rem;
}
.labs-section-header:first-of-type {
  margin-top: 0.25rem;
}
.labs-section-header mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.labs-coming-soon-placeholder {
  font-size: 0.8125rem;
  opacity: 0.5;
  font-style: italic;
  margin: 0.25rem 0 0 0;
}

.labs-feature-card {
  padding: 1.25rem;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 1rem;
  transition: background 0.15s ease;
}
.labs-feature-card .labs-feature-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.labs-feature-card .labs-feature-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  opacity: 0.5;
}
.labs-feature-card .labs-feature-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.labs-feature-card .labs-feature-title {
  font-weight: 600;
  font-size: 0.9375rem;
}
.labs-feature-card .labs-feature-description {
  margin: 0.75rem 0 0 0;
  font-size: 0.8125rem;
  opacity: 0.65;
  line-height: 1.6;
  padding-left: 2.25rem;
}

.coming-soon-chip {
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  background: rgba(255, 152, 0, 0.12);
  color: #e68a00;
  white-space: nowrap;
}

.recently-added-chip {
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  background: rgba(56, 142, 60, 0.12);
  color: #388e3c;
  white-space: nowrap;
}

:host-context(.dark) .tab-nav-container .tab-nav:hover {
  background-color: rgba(255, 255, 255, 0.05);
}
:host-context(.dark) .tab-nav-container .tab-nav.active {
  background-color: rgba(255, 255, 255, 0.1);
}
:host-context(.dark) .profile-section .profile-picture {
  background-color: rgba(255, 255, 255, 0.1);
}
:host-context(.dark) .background-type-toggle button.active {
  background-color: rgba(255, 255, 255, 0.1);
}
:host-context(.dark) .bg-preview-container .bg-preview:hover {
  border-color: rgba(255, 255, 255, 0.3);
}
:host-context(.dark) .bg-preview-container .bg-preview.empty {
  background-color: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}
:host-context(.dark) .bg-preview-container .bg-preview.empty:hover {
  background-color: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.3);
}
:host-context(.dark) .bg-preview-container .bg-preview.empty .add-icon {
  color: rgba(255, 255, 255, 0.4);
}
:host-context(.dark) .presets-grid .preset-btn.active {
  background-color: rgba(255, 255, 255, 0.1);
}
:host-context(.dark) .slider-row .slider,
:host-context(.dark) .transparency-row .slider {
  background: rgba(255, 255, 255, 0.2);
}
:host-context(.dark) .density-toggle-row button.active {
  background-color: var(--primary-color, #2aa198);
}
:host-context(.dark) .color-picker-item .picker-row .color-picker {
  border-color: rgba(255, 255, 255, 0.2);
}
:host-context(.dark) .color-picker-item .picker-row .color-hex-input {
  border-color: rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.05);
  color: inherit;
}
:host-context(.dark) .setup-item {
  background: rgba(255, 255, 255, 0.03);
}
:host-context(.dark) .setup-item.complete {
  background: rgba(76, 175, 80, 0.08);
}
:host-context(.dark) .setup-item.pending .status-icon {
  color: rgba(255, 255, 255, 0.3);
}
:host-context(.dark) .setup-item.disabled .status-icon {
  color: rgba(255, 255, 255, 0.2);
}
:host-context(.dark) .setup-item-progress {
  border-top-color: rgba(255, 255, 255, 0.1);
}
:host-context(.dark) .setup-item-auth-code {
  border-top-color: rgba(255, 255, 255, 0.1);
}
:host-context(.dark) .setup-complete-message {
  background: rgba(76, 175, 80, 0.15);
}
:host-context(.dark) .backend-card {
  border-color: rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.03);
}
:host-context(.dark) .backend-card:hover:not(.configured) {
  background: rgba(255, 255, 255, 0.06);
}
:host-context(.dark) .backend-card.is-selected:not(.configured) {
  background: rgba(42, 161, 152, 0.15);
}
:host-context(.dark) .backend-card.configured {
  background: rgba(76, 175, 80, 0.12);
}
:host-context(.dark) .backend-card.configured.is-selected {
  border-color: var(--primary-color, #2aa198);
  background: rgba(42, 161, 152, 0.15);
}
:host-context(.dark) .backend-card.not-installed {
  border-color: rgba(255, 152, 0, 0.3);
  background: rgba(255, 152, 0, 0.08);
}
:host-context(.dark) .backend-config {
  background: rgba(255, 255, 255, 0.03);
}
:host-context(.dark) .backend-config .install-command {
  background: rgba(255, 255, 255, 0.1);
}
:host-context(.dark) .device-auth-info {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
}
:host-context(.dark) .device-auth-info .device-code-row .device-code {
  background: rgba(255, 255, 255, 0.1);
}
:host-context(.dark) .labs-feature-card {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.1);
}
:host-context(.dark) .coming-soon-chip {
  background: rgba(255, 152, 0, 0.18);
  color: #ffb74d;
}
:host-context(.dark) .recently-added-chip {
  background: rgba(102, 187, 106, 0.18);
  color: #81c784;
}
:host-context(.dark) .service-card {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.1);
}

.services-section {
  margin-bottom: 24px;
}

.services-section-title {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.6;
  margin-bottom: 12px;
}

.services-description {
  font-size: 13px;
  opacity: 0.5;
}

.service-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(0, 0, 0, 0.02);
  margin-bottom: 8px;
}
.service-card.disabled {
  opacity: 0.45;
}

.service-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}
.service-icon.connected {
  background: rgba(76, 175, 80, 0.12);
  color: #4caf50;
}
.service-icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.service-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.service-name {
  font-size: 14px;
  font-weight: 500;
}

.service-desc {
  font-size: 12px;
  opacity: 0.5;
}

.service-status {
  flex-shrink: 0;
}
.service-status.connected {
  color: #4caf50;
}

.service-action {
  flex-shrink: 0;
}

.service-empty {
  font-size: 13px;
  opacity: 0.4;
  padding: 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.gw-embed-container {
  margin-top: 16px;
  border-radius: 8px;
  overflow: hidden;
  min-height: 300px;
}

.gw-embed-content {
  width: 100%;
  min-height: 300px;
}

.gw-embed-loading,
.gw-embed-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  font-size: 13px;
  opacity: 0.6;
}

.mic-select-field {
  width: 100%;
  max-width: 400px;
}

.audio-no-devices {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.audio-hint {
  font-size: 12px;
  opacity: 0.5;
  margin: 0;
}

.mic-test-area {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mic-test-meter {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mic-test-level-bar {
  flex: 1;
  max-width: 300px;
  height: 8px;
  background: var(--card-bg, rgba(255, 255, 255, 0.05));
  border-radius: 4px;
  overflow: hidden;
}

.mic-test-level-fill {
  height: 100%;
  background: #4caf50;
  border-radius: 4px;
  transition: width 50ms ease-out;
}

.mic-test-level-label {
  font-size: 12px;
  opacity: 0.6;
  min-width: 35px;
}

.mic-test-transcript {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  background: var(--card-bg, rgba(255, 255, 255, 0.05));
  border-radius: 8px;
  min-height: 40px;
  max-width: 500px;
  font-size: 13px;
}
.mic-test-transcript .transcript-icon {
  font-size: 18px;
  opacity: 0.5;
  flex-shrink: 0;
  margin-top: 1px;
}
.mic-test-transcript .transcript-placeholder {
  opacity: 0.4;
  font-style: italic;
}

.mic-test-error {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #f44336;
  font-size: 13px;
}
.mic-test-error mat-icon {
  font-size: 18px;
}

.mic-test-diagnostics {
  margin-top: 8px;
  background: rgba(244, 67, 54, 0.08);
  border: 1px solid rgba(244, 67, 54, 0.25);
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 12px;
}
.mic-test-diagnostics pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  color: rgba(255, 255, 255, 0.8);
  font-family: "JetBrains Mono", "Fira Code", monospace;
  font-size: 11px;
  line-height: 1.5;
  max-height: 200px;
  overflow-y: auto;
  -webkit-user-select: all;
          user-select: all;
}
.mic-test-diagnostics .copy-diagnostics-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 4px 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  cursor: pointer;
  transition: background 0.15s;
}
.mic-test-diagnostics .copy-diagnostics-btn mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.mic-test-diagnostics .copy-diagnostics-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.9);
}

.team-create-row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}
.team-create-row .team-name-field {
  flex: 1;
}
.team-create-row button {
  margin-top: 4px;
  min-width: 80px;
}

.team-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #f44336;
  font-size: 0.8125rem;
  margin-top: -0.5rem;
}
.team-error mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.teams-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 0;
  opacity: 0.7;
  font-size: 0.875rem;
}

.teams-empty {
  padding: 1.5rem 0;
  opacity: 0.5;
  font-size: 0.875rem;
}

.team-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.team-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 0.15);
  transition: background-color 0.15s ease;
}
.team-card:hover {
  background: rgba(128, 128, 128, 0.06);
}
.team-card.active {
  border-color: var(--primary-color, #2aa198);
  background: rgba(var(--primary-rgb, 42, 161, 152), 0.06);
}
.team-card .team-card-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  min-width: 0;
}
.team-card .team-avatar {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: var(--primary-color, #2aa198);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 0;
}
.team-card .team-card-details {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.team-card .team-card-name {
  font-weight: 500;
  font-size: 0.875rem;
}
.team-card .team-card-slug {
  font-size: 0.75rem;
  opacity: 0.5;
}
.team-card .team-card-actions {
  display: flex;
  gap: 0.25rem;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.team-card .team-card-actions mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.team-card:hover .team-card-actions {
  opacity: 1;
}
.team-card .team-edit-field {
  flex: 1;
  margin: -0.5rem 0;
}

.moved-note {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 12px 14px;
  border: 1px dashed rgba(128, 128, 128, 0.4);
  border-radius: 8px;
  margin: 10px 0;
  opacity: 0.85;
}
.moved-note mat-icon {
  opacity: 0.6;
}

.moved-link {
  background: transparent;
  border: 1px solid rgba(97, 175, 239, 0.55);
  border-radius: 999px;
  color: #61afef;
  cursor: pointer;
  padding: 2px 12px;
  font: inherit;
  font-size: 12px;
}
.moved-link:hover {
  background: rgba(97, 175, 239, 0.12);
}

.your-teams {
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 8px;
  padding: 12px 14px;
  margin: 10px 0;
}

.your-teams-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  margin-bottom: 4px;
}
.your-teams-head mat-icon {
  opacity: 0.6;
}
.your-teams-head .kc-link {
  margin-left: auto;
  font-size: 12px;
  color: #61afef;
  text-decoration: none;
}

.team-pill {
  display: inline-block;
  border: 1px solid rgba(97, 175, 239, 0.5);
  border-radius: 999px;
  padding: 2px 12px;
  margin: 2px 6px 2px 0;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/settings/settings.component.scss"],"names":[],"mappings":"AAAA;EACE;IAAW,mBAAA;IAAqB,UAAA;EAGhC;EAFA;IAAM,sBAAA;IAAwB,aAAA;EAM9B;AACF;AAJA;EACE,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAMF;AAJE;EACE,2BAAA;AAMJ;;AADA;EACE,aAAA;EACA,mCAAA;EACA,sDAAA;EACA,gCAAA;EACA,YAAA;EACA,sBAAA;AAIF;AAFE;EACE,aAAA;EACA,sBAAA;EACA,mCAAA;AAIJ;AADE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;AAGJ;;AAEA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AAAF;AAEE;EACE,SAAA;AAAJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAFF;AAIE;EACE,uBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;AAFJ;AAII;EACE,oBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAFN;AAKI;EACE,mBAAA;AAHN;AAMI;EACE,qCAAA;AAJN;AAOI;EACE,oCAAA;EACA,gBAAA;AALN;AAOM;EACE,UAAA;AALR;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AARF;AAUE;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AARJ;AAWE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AATJ;AAWI;EACE,gBAAA;EACA,mBAAA;AATN;AAYI;EACE,kBAAA;EACA,YAAA;AAVN;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,iCAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AAbF;AAeE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAbJ;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAfF;AAiBE;EACE,mBAAA;EACA,aAAA;AAfJ;;AAoBA;EACE,4GAAA;EACA,kHAAA;EACA,kHAAA;EACA,oHAAA;EAEA,wDAAA;EACA,wDAAA;EACA,0DAAA;AAlBF;;AAsBA;EACE,aAAA;EACA,WAAA;AAnBF;AAqBE;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;AAnBJ;AAqBI;EACE,+CAAA;EACA,YAAA;EACA,2CAAA;AAnBN;AAsBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApBN;;AA0BA;EACE,aAAA;EACA,WAAA;AAvBF;AAyBE;EACE,OAAA;EACA,oBAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,oCAAA;AAvBN;;AA6BA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AA1BF;AA4BE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gEAAA;AA1BJ;AA4BI;EACE,gCAAA;AA1BN;AA6BI;EACE,2CAAA;AA3BN;AA8BI;EACE,qCAAA;EACA,qCAAA;AA5BN;AA8BM;EACE,qCAAA;EACA,gCAAA;AA5BR;AA+BM;EACE,yBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA7BR;AAiCI;EACE,YAAA;EACA,yCAAA;AA/BN;AAkCI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,2DAAA;AAhCN;AAkCM;EACE,8BAAA;AAhCR;AAmCM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AAjCR;AAqCI;EACE,UAAA;AAnCN;;AAyCA;EACE,aAAA;EACA,8CAAA;EACA,WAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AAtCF;AAwCE;EACE,qBAAA;AAtCJ;AAyCE;EACE,mBAAA;EACA,mDAAA;AAvCJ;AA0CE;EACE,YAAA;EACA,yCAAA;EACA,eAAA;AAxCJ;;AA4CA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAzCF;AA2CE;EACE,mBAAA;EACA,YAAA;AAzCJ;AA4CE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA1CJ;;AA+CA;EACE,WAAA;AA5CF;;AAgDA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,kBAAA;AA7CF;;AAgDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AA7CF;AA+CE;EACE,oBAAA;EACA,YAAA;AA7CJ;AAgDE;EACE,mBAAA;EACA,gBAAA;EACA,sBAAA;AA9CJ;;AAkDA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA/CF;AAiDE;EACE,SAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AA/CJ;AAkDE;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;AAhDJ;AAkDI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhDN;;AAqDA;EACE,aAAA;EACA,+BAAA;EACA,kBAAA;AAlDF;AAoDE;EACE,qBAAA;AAlDJ;AAqDE;EACE,SAAA;EACA,mBAAA;EACA,YAAA;AAnDJ;;AAwDE;EACE,qCAAA;AArDJ;AAwDE;EACE,qCAAA;AAtDJ;;AA2DA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAxDF;AA0DE;EACE,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAxDJ;AA0DI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+CAAA;AAxDN;AA2DI;EACE,oCAAA;EACA,2CAAA;EACA,iBAAA;AAzDN;;AA+DE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA5DJ;AA+DE;;EAEE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AA7DJ;AAgEE;EACE,oCAAA;EACA,kBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kBAAA;AA9DJ;;AAmEA;EACE,aAAA;EACA,2DAAA;EACA,YAAA;AAhEF;;AAmEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAhEF;AAkEE;EACE,kBAAA;EACA,YAAA;AAhEJ;AAmEE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAjEJ;AAmEI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAjEN;AAmEM;EACE,YAAA;AAjER;AAoEM;EACE,kBAAA;EACA,YAAA;AAlER;AAsEI;EACE,OAAA;EACA,YAAA;EACA,wBAAA;EACA,sBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,+BAAA;EACA,yBAAA;AApEN;AAsEM;EACE,aAAA;EACA,2CAAA;AApER;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAxEF;AA0EE;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AAxEJ;AA0EI;EACE,kBAAA;AAxEN;AA4EE;EACE,OAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AA1EJ;AA4EI;EACE,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EAAA,gCAAA;AA1EN;AA4EM;EACE,qBAAA;AA1ER;AA8EI;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA5EN;AA+EI;EACE,aAAA;AA7EN;;AAmFA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAhFF;AAkFE;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AAhFJ;AAmFE;EACE,OAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AAjFJ;AAmFI;EACE,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EAAA,gCAAA;AAjFN;AAmFM;EACE,qBAAA;AAjFR;AAqFI;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAnFN;AAsFI;EACE,aAAA;AApFN;AAwFE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kCAAA;AAtFJ;;AA2FA;EACE,aAAA;EACA,WAAA;AAxFF;AA0FE;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;AAxFJ;AA0FI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxFN;AA2FI;EACE,+CAAA;EACA,YAAA;EACA,2CAAA;AAzFN;;AA+FA;EACE,aAAA;EACA,WAAA;AA5FF;AA8FE;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;AA5FJ;AA8FI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA5FN;AA+FI;EACE,+CAAA;EACA,YAAA;EACA,2CAAA;AA7FN;;AAmGA;EACE,aAAA;EACA,WAAA;AAhGF;AAkGE;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;AAhGJ;AAkGI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhGN;AAmGI;EACE,+CAAA;EACA,YAAA;EACA,2CAAA;AAjGN;;AAuGA;EACE,aAAA;EACA,WAAA;AApGF;AAsGE;EACE,OAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;AApGJ;AAsGI;EACE,+CAAA;EACA,YAAA;EACA,2CAAA;AApGN;;AA2GA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAxGF;;AA2GA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAxGF;;AA2GA;EACE,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,6BAAA;EACA,yBAAA;AAxGF;AA0GE;EACE,oCAAA;EACA,mCAAA;AAxGJ;AA0GI;EACE,cAAA;AAxGN;AA4GE;EACE,oCAAA;AA1GJ;AA4GI;EACE,yBAAA;AA1GN;AA8GE;EACE,YAAA;EACA,oBAAA;AA5GJ;AA8GI;EACE,yBAAA;AA5GN;;AAiHA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA9GF;AAgHE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9GJ;AAiHE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AA/GJ;AAiHI;EACE,gBAAA;EACA,oBAAA;AA/GN;AAkHI;EACE,oBAAA;EACA,YAAA;AAhHN;AAoHE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,oBAAA;AAlHJ;AAoHI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlHN;AAqHI;EACE,YAAA;AAnHN;AAsHI;EACE,cAAA;EACA,qBAAA;AApHN;AAwHE;EACE,cAAA;EACA,YAAA;AAtHJ;;AA0HA;EACE,mBAAA;EACA,oBAAA;EACA,wCAAA;AAvHF;AAyHE;EACE,qBAAA;AAvHJ;AA0HE;EACE,oBAAA;EACA,YAAA;AAxHJ;;AA4HA;EACE,mBAAA;EACA,oBAAA;EACA,wCAAA;AAzHF;AA2HE;EACE,oBAAA;EACA,YAAA;EACA,qBAAA;AAzHJ;AA4HE;EACE,WAAA;AA1HJ;AA4HI;EACE,mBAAA;AA1HN;AA8HE;EACE,mBAAA;EACA,aAAA;EACA,WAAA;AA5HJ;AA8HI;EACE,gBAAA;AA5HN;AA8HM;EACE,qBAAA;AA5HR;;AAkIA;EACE,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;AA/HF;AAiIE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/HJ;;AAmIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;EACA,qCAAA;AAhIF;AAkIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAhIJ;AAkII;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhIN;AAoIE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAlIJ;AAqIE;EACE,oBAAA;EACA,aAAA;EACA,qBAAA;AAnIJ;AAsIE;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;AApIJ;;AAwIA;EACE;IAAO,UAAA;IAAY,0BAAA;EAnInB;EAoIA;IAAO,UAAA;IAAY,wBAAA;EAhInB;AACF;AAmIA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAjIF;;AAoIA;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,+BAAA;AAjIF;AAmIE;EACE,2CAAA;EACA,+BAAA;AAjIJ;AAoIE;EACE,2CAAA;EACA,oCAAA;AAlIJ;AAqIE;EACE,qBAAA;EACA,mCAAA;EACA,eAAA;AAnIJ;AAqII;EACE,2CAAA;EACA,oCAAA;AAnIN;AAuIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AArIJ;AAwIE;EACE,gBAAA;EACA,oBAAA;AAtIJ;AAyIE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAvIJ;AA0IE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAxIJ;AA2IE;EACE,kBAAA;EACA,YAAA;AAzIJ;AA4IE;EACE,oCAAA;EACA,mCAAA;AA1IJ;AA6IE;EACE,YAAA;EACA,eAAA;EACA,oBAAA;AA3IJ;AA6II;EACE,8BAAA;AA3IN;;AAiJA;EACE,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;AA9IF;AAgJE;EACE,qBAAA;EACA,oBAAA;EACA,YAAA;AA9IJ;AAgJI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AA9IN;AAgJM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA9IR;AAmJE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AAjJJ;AAmJI;EACE,gBAAA;AAjJN;AAqJE;EACE,+CAAA;EACA,oBAAA;EACA,+BAAA;EACA,uBAAA;EACA,kBAAA;EACA,wBAAA;UAAA,gBAAA;AAnJJ;AAsJE;;EAEE,WAAA;EACA,sBAAA;AApJJ;AAsJI;;EACE,YAAA;EACA,8BAAA;AAnJN;AAqJM;;EACE,UAAA;AAlJR;AAqJM;;EACE,cAAA;AAlJR;AAqJM;;EACE,UAAA;EACA,0CAAA;AAlJR;AAmJQ;;EACE,sCAAA;AAhJV;AAqJI;;EACE,yBAAA;AAlJN;AAsJE;EACE,WAAA;EACA,sBAAA;AApJJ;;AAyJA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAtJF;;AA0JA;EACE,kBAAA;AAvJF;;AA0JA;EACE,+CAAA;EACA,yDAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAvJF;AAyJE;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AAvJJ;AAyJI;;EACE,gBAAA;AAtJN;AAyJI;;EACE,gDAAA;EACA,iBAAA;EACA,eAAA;AAtJN;AAyJI;;EACE,iCAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;AAtJN;AAwJM;;EACE,0BAAA;AArJR;AAyJI;;EACE,+CAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,qBAAA;EACA,+CAAA;EACA,wBAAA;EACA,kBAAA;AAtJN;AAyJI;;EACE,cAAA;AAtJN;AA0JE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,gDAAA;EACA,iBAAA;EACA,gBAAA;AAxJJ;AA0JI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AAxJN;;AA+JA;EACE,oBAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AA5JF;;AA+JA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,wBAAA;AA5JF;AA8JE;EACE,mBAAA;AA5JJ;AA+JE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7JJ;;AAiKA;EACE,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AA9JF;;AAiKA;EACE,gBAAA;EACA,mBAAA;EACA,+BAAA;EACA,qCAAA;EACA,mBAAA;EACA,iCAAA;AA9JF;AAgKE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA9JJ;AAiKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA/JJ;AAkKE;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAhKJ;AAmKE;EACE,gBAAA;EACA,oBAAA;AAjKJ;AAoKE;EACE,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;AAlKJ;;AAsKA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mCAAA;EACA,cAAA;EACA,mBAAA;AAnKF;;AAsKA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mCAAA;EACA,cAAA;EACA,mBAAA;AAnKF;;AAyKI;EACE,2CAAA;AAtKN;AAyKI;EACE,0CAAA;AAvKN;AA2KE;EACE,0CAAA;AAzKJ;AA4KE;EACE,0CAAA;AA1KJ;AA8KI;EACE,sCAAA;AA5KN;AA+KI;EACE,2CAAA;EACA,sCAAA;AA7KN;AA+KM;EACE,2CAAA;EACA,sCAAA;AA7KR;AAgLM;EACE,+BAAA;AA9KR;AAmLE;EACE,0CAAA;AAjLJ;AAoLE;;EAEE,oCAAA;AAlLJ;AAqLE;EACE,+CAAA;AAnLJ;AAwLM;EACE,sCAAA;AAtLR;AAyLM;EACE,uCAAA;EACA,qCAAA;EACA,cAAA;AAvLR;AA6LE;EACE,qCAAA;AA3LJ;AA6LI;EACE,mCAAA;AA3LN;AA8LI;EACE,+BAAA;AA5LN;AA+LI;EACE,+BAAA;AA7LN;AAiME;EACE,0CAAA;AA/LJ;AAkME;EACE,0CAAA;AAhMJ;AAmME;EACE,mCAAA;AAjMJ;AAqME;EACE,uCAAA;EACA,qCAAA;AAnMJ;AAqMI;EACE,qCAAA;AAnMN;AAsMI;EACE,oCAAA;AApMN;AAuMI;EACE,mCAAA;AArMN;AAuMM;EACE,2CAAA;EACA,oCAAA;AArMR;AAyMI;EACE,oCAAA;EACA,mCAAA;AAvMN;AA2ME;EACE,qCAAA;AAzMJ;AA2MI;EACE,oCAAA;AAzMN;AA6ME;EACE,qCAAA;EACA,sCAAA;AA3MJ;AA6MI;EACE,oCAAA;AA3MN;AAgNE;EACE,qCAAA;EACA,sCAAA;AA9MJ;AAiNE;EACE,mCAAA;EACA,cAAA;AA/MJ;AAkNE;EACE,qCAAA;EACA,cAAA;AAhNJ;AAmNE;EACE,qCAAA;EACA,sCAAA;AAjNJ;;AAuNA;EACE,mBAAA;AApNF;;AAuNA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AApNF;;AAuNA;EACE,eAAA;EACA,YAAA;AApNF;;AAuNA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;EACA,kBAAA;AApNF;AAsNE;EACE,aAAA;AApNJ;;AAwNA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AArNF;AAuNE;EACE,mCAAA;EACA,cAAA;AArNJ;AAwNE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtNJ;;AA0NA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;AAvNF;;AA0NA;EACE,eAAA;EACA,gBAAA;AAvNF;;AA0NA;EACE,eAAA;EACA,YAAA;AAvNF;;AA0NA;EACE,cAAA;AAvNF;AAyNE;EACE,cAAA;AAvNJ;;AA2NA;EACE,cAAA;AAxNF;;AA2NA;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAxNF;;AA2NA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAxNF;;AA2NA;EACE,WAAA;EACA,iBAAA;AAxNF;;AA2NA;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;AAxNF;;AA6NA;EACE,WAAA;EACA,gBAAA;AA1NF;;AA6NA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AA1NF;;AA6NA;EACE,eAAA;EACA,YAAA;EACA,SAAA;AA1NF;;AA6NA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA1NF;;AA6NA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA1NF;;AA6NA;EACE,OAAA;EACA,gBAAA;EACA,WAAA;EACA,qDAAA;EACA,kBAAA;EACA,gBAAA;AA1NF;;AA6NA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;AA1NF;;AA6NA;EACE,eAAA;EACA,YAAA;EACA,eAAA;AA1NF;;AA6NA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,qDAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA1NF;AA4NE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AA1NJ;AA6NE;EACE,YAAA;EACA,kBAAA;AA3NJ;;AA+NA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AA5NF;AA8NE;EACE,eAAA;AA5NJ;;AAgOA;EACE,eAAA;EACA,mCAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA7NF;AA+NE;EACE,SAAA;EACA,qBAAA;EACA,sBAAA;EACA,+BAAA;EACA,qDAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;UAAA,gBAAA;AA7NJ;AAgOE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;EACA,4BAAA;AA9NJ;AAgOI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9NN;AAiOI;EACE,qCAAA;EACA,+BAAA;AA/NN;;AAsOA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AAnOF;AAqOE;EACE,OAAA;AAnOJ;AAsOE;EACE,eAAA;EACA,eAAA;AApOJ;;AAwOA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;AArOF;AAuOE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArOJ;;AAyOA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AAtOF;;AAyOA;EACE,iBAAA;EACA,YAAA;EACA,mBAAA;AAtOF;;AAyOA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAtOF;;AAyOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;EACA,uCAAA;AAtOF;AAwOE;EACE,qCAAA;AAtOJ;AAyOE;EACE,2CAAA;EACA,wDAAA;AAvOJ;AA0OE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;AAxOJ;AA2OE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAzOJ;AA4OE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA1OJ;AA6OE;EACE,gBAAA;EACA,mBAAA;AA3OJ;AA8OE;EACE,kBAAA;EACA,YAAA;AA5OJ;AA+OE;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,8BAAA;AA7OJ;AA+OI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7ON;AAiPE;EACE,UAAA;AA/OJ;AAkPE;EACE,OAAA;EACA,iBAAA;AAhPJ;;AAoPA;EAAc,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;EAAiB,kBAAA;EAAoB,2CAAA;EAAyC,kBAAA;EAAoB,cAAA;EAAgB,aAAA;AAxO/K;AAyOE;EAAW,YAAA;AAtOb;;AAwOA;EAAc,uBAAA;EAAyB,0CAAA;EAAwC,oBAAA;EAAsB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,aAAA;EAAe,eAAA;AA7NxK;AA8NE;EAAU,oCAAA;AA3NZ;;AA6NA;EAAc,0CAAA;EAAwC,kBAAA;EAAoB,kBAAA;EAAoB,cAAA;AAtN9F;;AAuNA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,kBAAA;AA/MnF;AAgNE;EAAW,YAAA;AA7Mb;AA6M4B;EAAW,iBAAA;EAAmB,eAAA;EAAiB,cAAA;EAAgB,qBAAA;AAvM3F;;AAwMA;EAAa,qBAAA;EAAuB,yCAAA;EAAuC,oBAAA;EAAsB,iBAAA;EAAmB,qBAAA;EAAuB,eAAA;AA/L3I","sourcesContent":["@keyframes throb {\n  0%, 100% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.18); opacity: 0.75; }\n}\n\n:host {\n  display: block;\n  user-select: none;\n  font-size: 0.875rem;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  &:not(.widget) {\n    backdrop-filter: blur(20px);\n  }\n}\n\n// Split container layout with sidebar tabs\n.split-container {\n  display: grid;\n  gap: var(--density-spacing, 1.5rem);\n  padding: var(--density-padding, 1rem) 2rem 2rem 1.5rem;\n  grid-template-columns: 140px 1fr;\n  height: 100%;\n  box-sizing: border-box;\n\n  .sidenav {\n    display: flex;\n    flex-direction: column;\n    gap: var(--density-spacing, 1.5rem);\n  }\n\n  .main {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: calc(var(--density-spacing, 1rem) * 2);\n    overflow-y: auto;\n    min-height: 0;\n    padding: 10px;\n    padding-bottom: 30px;\n  }\n}\n\n// Tab title\n.tab-title {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.25rem;\n  font-weight: 500;\n  opacity: 0.8;\n}\n\n// Tab header with title and actions\n.tab-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n\n  .tab-title {\n    margin: 0;\n  }\n}\n\n// Tab navigation\n.tab-nav-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n\n  .tab-nav {\n    padding: 0.5rem 0.75rem;\n    justify-content: flex-start;\n    text-align: left;\n    border-radius: 8px;\n    transition: background-color 0.15s ease;\n\n    mat-icon {\n      margin-right: 0.5rem;\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n      opacity: 0.7;\n    }\n\n    span {\n      font-size: 0.875rem;\n    }\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n\n    &.active {\n      background-color: rgba(0, 0, 0, 0.1);\n      font-weight: 500;\n\n      mat-icon {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.profile-section {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n\n  .profile-picture {\n    height: 2.5rem;\n    width: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid currentColor;\n    background-color: rgba(0, 0, 0, 0.1);\n    border-radius: 50%;\n    font-size: 1.25rem;\n    font-weight: bold;\n  }\n\n  .profile-info {\n    display: flex;\n    flex-direction: column;\n    line-height: 1.3;\n\n    .username {\n      font-weight: 600;\n      font-size: 0.875rem;\n    }\n\n    .team {\n      font-size: 0.75rem;\n      opacity: 0.7;\n    }\n  }\n}\n\n// Setting sections\n.setting-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--density-spacing, 1rem);\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n  font-size: 0.9375rem;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    opacity: 0.7;\n  }\n}\n\n// Generic boolean toggle row (label + slide toggle)\n.toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n\n  .toggle-label {\n    font-size: 0.875rem;\n    opacity: 0.85;\n  }\n}\n\n// Slide toggle: soften selected track; keep unselected track neutral (no blue bleed)\n::ng-deep .primary-toggle {\n  --mat-slide-toggle-selected-track-color: color-mix(in srgb, var(--preset-primary, #1976d2) 30%, transparent);\n  --mat-slide-toggle-selected-hover-track-color: color-mix(in srgb, var(--preset-primary, #1976d2) 35%, transparent);\n  --mat-slide-toggle-selected-focus-track-color: color-mix(in srgb, var(--preset-primary, #1976d2) 35%, transparent);\n  --mat-slide-toggle-selected-pressed-track-color: color-mix(in srgb, var(--preset-primary, #1976d2) 35%, transparent);\n  // Prevent primary color from bleeding into the OFF state on hover/focus\n  --mat-slide-toggle-unselected-hover-track-color: #616161;\n  --mat-slide-toggle-unselected-focus-track-color: #616161;\n  --mat-slide-toggle-unselected-pressed-track-color: #616161;\n}\n\n// Theme toggle buttons\n.theme-toggle-row {\n  display: flex;\n  gap: 0.5rem;\n\n  button {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    transition: all 0.15s ease;\n\n    &.active {\n      background-color: var(--primary-color, #1976d2);\n      color: white;\n      border-color: var(--primary-color, #1976d2);\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n// Background type toggle\n.background-type-toggle {\n  display: flex;\n  gap: 0.5rem;\n\n  button {\n    flex: 1;\n    padding: 0.5rem 1rem;\n    border-radius: 6px;\n\n    &.active {\n      background-color: rgba(0, 0, 0, 0.1);\n    }\n  }\n}\n\n// Background image previews\n.bg-preview-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n\n  .bg-preview {\n    position: relative;\n    width: 100px;\n    height: 70px;\n    border-radius: 8px;\n    background-size: cover;\n    background-position: center;\n    border: 2px solid transparent;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: border-color 0.15s ease, background-color 0.15s ease;\n\n    &:hover {\n      border-color: rgba(0, 0, 0, 0.3);\n    }\n\n    &.selected {\n      border-color: var(--primary-color, #1976d2);\n    }\n\n    &.empty {\n      background-color: rgba(0, 0, 0, 0.08);\n      border: 2px dashed rgba(0, 0, 0, 0.2);\n\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.12);\n        border-color: rgba(0, 0, 0, 0.3);\n      }\n\n      .add-icon {\n        color: rgba(0, 0, 0, 0.4);\n        font-size: 28px;\n        width: 28px;\n        height: 28px;\n      }\n    }\n\n    .check-icon {\n      color: white;\n      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);\n    }\n\n    .replace-btn {\n      position: absolute;\n      bottom: 4px;\n      right: 4px;\n      width: 22px;\n      height: 22px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: rgba(0, 0, 0, 0.6);\n      border-radius: 4px;\n      opacity: 0;\n      cursor: pointer;\n      transition: opacity 0.15s ease, background-color 0.15s ease;\n\n      &:hover {\n        background: rgba(0, 0, 0, 0.8);\n      }\n\n      mat-icon {\n        font-size: 14px;\n        width: 14px;\n        height: 14px;\n        color: white;\n        text-shadow: none;\n      }\n    }\n\n    &:hover .replace-btn {\n      opacity: 1;\n    }\n  }\n}\n\n// Color swatches grid\n.color-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 40px);\n  gap: 0.5rem;\n}\n\n.color-swatch {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n\n  &:hover {\n    transform: scale(1.1);\n  }\n\n  &.selected {\n    border-color: white;\n    box-shadow: 0 0 0 2px var(--primary-color, #1976d2);\n  }\n\n  mat-icon {\n    color: white;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n    font-size: 18px;\n  }\n}\n\n.custom-color-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n\n  span {\n    font-size: 0.875rem;\n    opacity: 0.8;\n  }\n\n  .color-picker {\n    width: 40px;\n    height: 32px;\n    padding: 0;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n}\n\n// Chart theme select\n.chart-select {\n  width: 100%;\n}\n\n// System tab styles\n.system-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 1rem;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 8px;\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.25rem 0;\n\n  .info-label {\n    font-size: 0.8125rem;\n    opacity: 0.7;\n  }\n\n  .info-value {\n    font-size: 0.875rem;\n    font-weight: 500;\n    font-family: monospace;\n  }\n}\n\n.trust-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n\n  .trust-description {\n    margin: 0;\n    font-size: 0.8125rem;\n    opacity: 0.8;\n    line-height: 1.5;\n  }\n\n  button {\n    align-self: flex-start;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n.trust-status {\n  padding: 1rem;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 8px;\n\n  mat-progress-bar {\n    margin-bottom: 0.5rem;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.875rem;\n    opacity: 0.8;\n  }\n}\n\n:host-context(.dark) {\n  .system-info {\n    background: rgba(255, 255, 255, 0.03);\n  }\n\n  .trust-status {\n    background: rgba(255, 255, 255, 0.05);\n  }\n}\n\n// Preset buttons grid\n.presets-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n\n  .preset-btn {\n    padding: 0.5rem 1rem;\n    border-radius: 6px;\n    font-size: 0.8125rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n\n    .preset-indicator {\n      width: 12px;\n      height: 12px;\n      border-radius: 50%;\n      background-color: var(--preset-accent, #2aa198);\n    }\n\n    &.active {\n      background-color: rgba(0, 0, 0, 0.1);\n      border-color: var(--preset-accent, #2aa198);\n      border-width: 2px;\n    }\n  }\n}\n\n.section-header {\n  .clear-preset-btn {\n    margin-left: auto;\n    font-size: 0.75rem;\n    min-width: auto;\n    padding: 0 0.5rem;\n    line-height: 1.5;\n  }\n\n  .size-value,\n  .custom-indicator {\n    margin-left: auto;\n    font-size: 0.875rem;\n    font-weight: 500;\n    opacity: 0.8;\n  }\n\n  .custom-indicator {\n    color: var(--primary-color, #2aa198);\n    font-size: 0.75rem;\n    padding: 0.125rem 0.5rem;\n    background: rgba(42, 161, 152, 0.1);\n    border-radius: 4px;\n  }\n}\n\n// Custom color picker grid\n.color-picker-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 0.75rem;\n}\n\n.color-picker-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n\n  label {\n    font-size: 0.75rem;\n    opacity: 0.7;\n  }\n\n  .picker-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n\n    .color-picker {\n      width: 32px;\n      height: 32px;\n      padding: 0;\n      border: 2px solid rgba(0, 0, 0, 0.1);\n      border-radius: 6px;\n      cursor: pointer;\n      background: none;\n\n      &::-webkit-color-swatch-wrapper {\n        padding: 2px;\n      }\n\n      &::-webkit-color-swatch {\n        border-radius: 4px;\n        border: none;\n      }\n    }\n\n    .color-hex-input {\n      flex: 1;\n      min-width: 0;\n      padding: 0.375rem 0.5rem;\n      font-family: monospace;\n      font-size: 0.8rem;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n      border-radius: 4px;\n      background: rgba(0, 0, 0, 0.03);\n      text-transform: uppercase;\n\n      &:focus {\n        outline: none;\n        border-color: var(--primary-color, #2aa198);\n      }\n    }\n  }\n}\n\n// Font size slider\n.slider-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n\n  .slider-label {\n    font-size: 0.75rem;\n    opacity: 0.6;\n    user-select: none;\n\n    &.large {\n      font-size: 1.25rem;\n    }\n  }\n\n  .slider {\n    flex: 1;\n    height: 4px;\n    -webkit-appearance: none;\n    appearance: none;\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 2px;\n    cursor: pointer;\n\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      width: 16px;\n      height: 16px;\n      background: var(--primary-color, #2aa198);\n      border-radius: 50%;\n      cursor: pointer;\n      transition: transform 0.15s ease;\n\n      &:hover {\n        transform: scale(1.1);\n      }\n    }\n\n    &::-moz-range-thumb {\n      width: 16px;\n      height: 16px;\n      background: var(--primary-color, #2aa198);\n      border: none;\n      border-radius: 50%;\n      cursor: pointer;\n    }\n\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n// Transparency sliders\n.transparency-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n\n  label {\n    min-width: 60px;\n    font-size: 0.875rem;\n    opacity: 0.8;\n  }\n\n  .slider {\n    flex: 1;\n    height: 4px;\n    -webkit-appearance: none;\n    appearance: none;\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 2px;\n    cursor: pointer;\n\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      width: 16px;\n      height: 16px;\n      background: var(--primary-color, #2aa198);\n      border-radius: 50%;\n      cursor: pointer;\n      transition: transform 0.15s ease;\n\n      &:hover {\n        transform: scale(1.1);\n      }\n    }\n\n    &::-moz-range-thumb {\n      width: 16px;\n      height: 16px;\n      background: var(--primary-color, #2aa198);\n      border: none;\n      border-radius: 50%;\n      cursor: pointer;\n    }\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .opacity-value {\n    min-width: 45px;\n    text-align: right;\n    font-size: 0.875rem;\n    opacity: 0.8;\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n// UI Density toggle - matches theme-toggle-row style\n.density-toggle-row {\n  display: flex;\n  gap: 0.5rem;\n\n  button {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    transition: all 0.15s ease;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    &.active {\n      background-color: var(--primary-color, #1976d2);\n      color: white;\n      border-color: var(--primary-color, #1976d2);\n    }\n  }\n}\n\n// Toolbar position toggle - matches density-toggle-row style\n.position-toggle-row {\n  display: flex;\n  gap: 0.5rem;\n\n  button {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    transition: all 0.15s ease;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    &.active {\n      background-color: var(--primary-color, #1976d2);\n      color: white;\n      border-color: var(--primary-color, #1976d2);\n    }\n  }\n}\n\n// Layout mode toggle - matches position-toggle-row style\n.layout-toggle-row {\n  display: flex;\n  gap: 0.5rem;\n\n  button {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    transition: all 0.15s ease;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    &.active {\n      background-color: var(--primary-color, #1976d2);\n      color: white;\n      border-color: var(--primary-color, #1976d2);\n    }\n  }\n}\n\n// Message width toggle\n.width-toggle-row {\n  display: flex;\n  gap: 0.5rem;\n\n  button {\n    flex: 1;\n    padding: 0.5rem 0.75rem;\n    border-radius: 6px;\n    font-size: 0.8125rem;\n    transition: all 0.15s ease;\n\n    &.active {\n      background-color: var(--primary-color, #1976d2);\n      color: white;\n      border-color: var(--primary-color, #1976d2);\n    }\n  }\n}\n\n// ==================== SETUP TAB ====================\n\n.setup-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  font-size: 0.875rem;\n  opacity: 0.7;\n}\n\n.setup-checklist {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.setup-item {\n  padding: 1rem;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.03);\n  border: 2px solid transparent;\n  transition: all 0.2s ease;\n\n  &.complete {\n    border-color: rgba(76, 175, 80, 0.3);\n    background: rgba(76, 175, 80, 0.05);\n\n    .status-icon {\n      color: #4caf50;\n    }\n  }\n\n  &.pending {\n    border-color: rgba(255, 152, 0, 0.3);\n\n    .status-icon {\n      color: rgba(0, 0, 0, 0.3);\n    }\n  }\n\n  &.disabled {\n    opacity: 0.5;\n    pointer-events: none;\n\n    .status-icon {\n      color: rgba(0, 0, 0, 0.2);\n    }\n  }\n}\n\n.setup-item-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n\n  .status-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n\n  .setup-item-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.125rem;\n\n    .setup-item-title {\n      font-weight: 500;\n      font-size: 0.9375rem;\n    }\n\n    .setup-item-status {\n      font-size: 0.8125rem;\n      opacity: 0.7;\n    }\n  }\n\n  .setup-action-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.375rem;\n    padding: 0.5rem 1rem;\n    font-size: 0.8125rem;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    &.secondary {\n      opacity: 0.7;\n    }\n\n    &.warn {\n      color: #f44336;\n      border-color: #f44336;\n    }\n  }\n\n  .done-icon {\n    color: #4caf50;\n    opacity: 0.7;\n  }\n}\n\n.setup-item-progress {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n\n  mat-progress-bar {\n    margin-bottom: 0.5rem;\n  }\n\n  .progress-text {\n    font-size: 0.8125rem;\n    opacity: 0.7;\n  }\n}\n\n.setup-item-auth-code {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n\n  .auth-instructions {\n    font-size: 0.8125rem;\n    opacity: 0.7;\n    margin: 0 0 0.75rem 0;\n  }\n\n  .auth-code-field {\n    width: 100%;\n\n    ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n      margin-top: 0.25rem;\n    }\n  }\n\n  .auth-code-actions {\n    margin-top: 0.75rem;\n    display: flex;\n    gap: 0.5rem;\n\n    button {\n      min-width: 120px;\n\n      mat-spinner {\n        display: inline-block;\n      }\n    }\n  }\n}\n\n.setup-item-error {\n  margin-top: 0.75rem;\n  padding: 0.5rem 0.75rem;\n  background: rgba(244, 67, 54, 0.1);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #f44336;\n  font-size: 0.8125rem;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.setup-complete-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1.75rem 1.5rem;\n  margin-top: 1rem;\n  background: rgba(76, 175, 80, 0.1);\n  border-radius: 12px;\n  animation: fadeSlideIn 0.35s ease-out;\n\n  .setup-complete-celebration {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: #4caf50;\n\n    mat-icon {\n      font-size: 26px;\n      width: 26px;\n      height: 26px;\n    }\n  }\n\n  .setup-complete-title {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #4caf50;\n  }\n\n  .setup-complete-subtitle {\n    font-size: 0.8125rem;\n    opacity: 0.75;\n    margin-bottom: 0.5rem;\n  }\n\n  .setup-complete-cta {\n    width: 100%;\n    margin-top: 0.25rem;\n    font-size: 0.9375rem;\n    font-weight: 500;\n    letter-spacing: 0.02em;\n  }\n}\n\n@keyframes fadeSlideIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n// Backend selection cards\n.backend-cards {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.backend-card {\n  flex: 1;\n  min-width: 140px;\n  max-width: 200px;\n  padding: 0.875rem;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  background: rgba(0, 0, 0, 0.02);\n\n  &:hover:not(.configured) {\n    border-color: var(--primary-color, #2aa198);\n    background: rgba(0, 0, 0, 0.04);\n  }\n\n  &.is-selected:not(.configured) {\n    border-color: var(--primary-color, #2aa198);\n    background: rgba(42, 161, 152, 0.08);\n  }\n\n  &.configured {\n    border-color: #4caf50;\n    background: rgba(76, 175, 80, 0.08);\n    cursor: pointer;\n\n    &.is-selected {\n      border-color: var(--primary-color, #2aa198);\n      background: rgba(42, 161, 152, 0.08);\n    }\n  }\n\n  .backend-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 0.25rem;\n  }\n\n  .backend-name {\n    font-weight: 500;\n    font-size: 0.9375rem;\n  }\n\n  .configured-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: #4caf50;\n  }\n\n  .not-installed-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: #ff9800;\n  }\n\n  .backend-desc {\n    font-size: 0.75rem;\n    opacity: 0.6;\n  }\n\n  &.not-installed {\n    border-color: rgba(255, 152, 0, 0.3);\n    background: rgba(255, 152, 0, 0.05);\n  }\n\n  &.coming-soon {\n    opacity: 0.5;\n    cursor: default;\n    pointer-events: none;\n\n    .backend-card-header {\n      justify-content: space-between;\n    }\n  }\n}\n\n// Backend configuration panel\n.backend-config {\n  margin-top: 0.75rem;\n  padding: 0.75rem;\n  background: rgba(0, 0, 0, 0.02);\n  border-radius: 8px;\n\n  .config-instructions {\n    margin: 0 0 0.75rem 0;\n    font-size: 0.8125rem;\n    opacity: 0.8;\n\n    &.config-instructions-ok {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      opacity: 1;\n\n      .configured-inline-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        color: #4caf50;\n      }\n    }\n  }\n\n  .config-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.75rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  .install-command {\n    font-family: 'Fira Code', 'Consolas', monospace;\n    font-size: 0.8125rem;\n    background: rgba(0, 0, 0, 0.08);\n    padding: 0.5rem 0.75rem;\n    border-radius: 4px;\n    user-select: all;\n  }\n\n  .api-key-field,\n  .auth-code-field {\n    width: 100%;\n    margin-bottom: 1.25rem;\n\n    .field-action-btn {\n      opacity: 0.7;\n      transition: opacity 0.15s ease;\n\n      &:hover {\n        opacity: 1;\n      }\n\n      &.warn {\n        color: #f44336;\n      }\n\n      &.field-action-btn-throb {\n        opacity: 1;\n        animation: throb 1.4s ease-in-out infinite;\n        mat-icon {\n          color: var(--mat-sys-primary, #3f51b5);\n        }\n      }\n    }\n\n    .hint-success {\n      color: #4caf50 !important;\n    }\n  }\n\n  .model-select-field {\n    width: 100%;\n    margin-bottom: 0.75rem;\n  }\n}\n\n// Add provider button container\n.add-provider {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n}\n\n// Device code auth flow (for ChatGPT/Codex)\n.device-auth-flow {\n  margin-top: 0.5rem;\n}\n\n.device-auth-info {\n  background: var(--card-bg, rgba(0, 0, 0, 0.05));\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));\n  border-radius: 8px;\n  padding: 1rem;\n  margin: 0.75rem 0;\n\n  .device-url-row,\n  .device-code-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.75rem;\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n\n    .device-label {\n      color: var(--text-secondary, rgba(0, 0, 0, 0.6));\n      font-size: 0.8rem;\n      min-width: 40px;\n    }\n\n    .device-url {\n      color: var(--link-color, #2196f3);\n      font-size: 0.875rem;\n      text-decoration: none;\n      word-break: break-all;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    .device-code {\n      font-family: 'Fira Code', 'Consolas', monospace;\n      font-size: 1.5rem;\n      font-weight: 600;\n      color: var(--primary-color, #1976d2);\n      letter-spacing: 0.1em;\n      background: var(--code-bg, rgba(0, 0, 0, 0.08));\n      padding: 0.25rem 0.75rem;\n      border-radius: 4px;\n    }\n\n    button {\n      flex-shrink: 0;\n    }\n  }\n\n  .device-note {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    margin: 1rem 0 0 0;\n    color: var(--text-secondary, rgba(0, 0, 0, 0.6));\n    font-size: 0.8rem;\n    line-height: 1.4;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      flex-shrink: 0;\n      margin-top: 2px;\n      opacity: 0.7;\n    }\n  }\n}\n\n// ==================== LABS TAB ====================\n\n.labs-subtitle {\n  margin: 0 0 1.5rem 0;\n  font-size: 0.8125rem;\n  opacity: 0.6;\n  line-height: 1.5;\n}\n\n.labs-section-header {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  opacity: 0.45;\n  margin: 1.5rem 0 0.75rem;\n\n  &:first-of-type {\n    margin-top: 0.25rem;\n  }\n\n  mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n  }\n}\n\n.labs-coming-soon-placeholder {\n  font-size: 0.8125rem;\n  opacity: 0.5;\n  font-style: italic;\n  margin: 0.25rem 0 0 0;\n}\n\n.labs-feature-card {\n  padding: 1.25rem;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.03);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  margin-bottom: 1rem;\n  transition: background 0.15s ease;\n\n  .labs-feature-header {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n  }\n\n  .labs-feature-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n    opacity: 0.5;\n  }\n\n  .labs-feature-info {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .labs-feature-title {\n    font-weight: 600;\n    font-size: 0.9375rem;\n  }\n\n  .labs-feature-description {\n    margin: 0.75rem 0 0 0;\n    font-size: 0.8125rem;\n    opacity: 0.65;\n    line-height: 1.6;\n    padding-left: 2.25rem; // align with title (icon width + gap)\n  }\n}\n\n.coming-soon-chip {\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 0.125rem 0.5rem;\n  border-radius: 4px;\n  background: rgba(255, 152, 0, 0.12);\n  color: #e68a00;\n  white-space: nowrap;\n}\n\n.recently-added-chip {\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 0.125rem 0.5rem;\n  border-radius: 4px;\n  background: rgba(56, 142, 60, 0.12);\n  color: #388e3c;\n  white-space: nowrap;\n}\n\n// Dark mode adjustments\n:host-context(.dark) {\n  .tab-nav-container .tab-nav {\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.05);\n    }\n\n    &.active {\n      background-color: rgba(255, 255, 255, 0.1);\n    }\n  }\n\n  .profile-section .profile-picture {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .background-type-toggle button.active {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .bg-preview-container .bg-preview {\n    &:hover {\n      border-color: rgba(255, 255, 255, 0.3);\n    }\n\n    &.empty {\n      background-color: rgba(255, 255, 255, 0.08);\n      border-color: rgba(255, 255, 255, 0.2);\n\n      &:hover {\n        background-color: rgba(255, 255, 255, 0.12);\n        border-color: rgba(255, 255, 255, 0.3);\n      }\n\n      .add-icon {\n        color: rgba(255, 255, 255, 0.4);\n      }\n    }\n  }\n\n  .presets-grid .preset-btn.active {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .slider-row .slider,\n  .transparency-row .slider {\n    background: rgba(255, 255, 255, 0.2);\n  }\n\n  .density-toggle-row button.active {\n    background-color: var(--primary-color, #2aa198);\n  }\n\n  .color-picker-item {\n    .picker-row {\n      .color-picker {\n        border-color: rgba(255, 255, 255, 0.2);\n      }\n\n      .color-hex-input {\n        border-color: rgba(255, 255, 255, 0.15);\n        background: rgba(255, 255, 255, 0.05);\n        color: inherit;\n      }\n    }\n  }\n\n  // Setup tab dark mode\n  .setup-item {\n    background: rgba(255, 255, 255, 0.03);\n\n    &.complete {\n      background: rgba(76, 175, 80, 0.08);\n    }\n\n    &.pending .status-icon {\n      color: rgba(255, 255, 255, 0.3);\n    }\n\n    &.disabled .status-icon {\n      color: rgba(255, 255, 255, 0.2);\n    }\n  }\n\n  .setup-item-progress {\n    border-top-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .setup-item-auth-code {\n    border-top-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .setup-complete-message {\n    background: rgba(76, 175, 80, 0.15);\n  }\n\n  // Backend cards dark mode\n  .backend-card {\n    border-color: rgba(255, 255, 255, 0.12);\n    background: rgba(255, 255, 255, 0.03);\n\n    &:hover:not(.configured) {\n      background: rgba(255, 255, 255, 0.06);\n    }\n\n    &.is-selected:not(.configured) {\n      background: rgba(42, 161, 152, 0.15);\n    }\n\n    &.configured {\n      background: rgba(76, 175, 80, 0.12);\n\n      &.is-selected {\n        border-color: var(--primary-color, #2aa198);\n        background: rgba(42, 161, 152, 0.15);\n      }\n    }\n\n    &.not-installed {\n      border-color: rgba(255, 152, 0, 0.3);\n      background: rgba(255, 152, 0, 0.08);\n    }\n  }\n\n  .backend-config {\n    background: rgba(255, 255, 255, 0.03);\n\n    .install-command {\n      background: rgba(255, 255, 255, 0.1);\n    }\n  }\n\n  .device-auth-info {\n    background: rgba(255, 255, 255, 0.05);\n    border-color: rgba(255, 255, 255, 0.1);\n\n    .device-code-row .device-code {\n      background: rgba(255, 255, 255, 0.1);\n    }\n  }\n\n  // Labs tab dark mode\n  .labs-feature-card {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .coming-soon-chip {\n    background: rgba(255, 152, 0, 0.18);\n    color: #ffb74d;\n  }\n\n  .recently-added-chip {\n    background: rgba(102, 187, 106, 0.18);\n    color: #81c784;\n  }\n\n  .service-card {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n}\n\n// --- Connected Services tab ---\n\n.services-section {\n  margin-bottom: 24px;\n}\n\n.services-section-title {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.6;\n  margin-bottom: 12px;\n}\n\n.services-description {\n  font-size: 13px;\n  opacity: 0.5;\n}\n\n.service-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: rgba(0, 0, 0, 0.02);\n  margin-bottom: 8px;\n\n  &.disabled {\n    opacity: 0.45;\n  }\n}\n\n.service-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.06);\n  flex-shrink: 0;\n\n  &.connected {\n    background: rgba(76, 175, 80, 0.12);\n    color: #4caf50;\n  }\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.service-info {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.service-name {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.service-desc {\n  font-size: 12px;\n  opacity: 0.5;\n}\n\n.service-status {\n  flex-shrink: 0;\n\n  &.connected {\n    color: #4caf50;\n  }\n}\n\n.service-action {\n  flex-shrink: 0;\n}\n\n.service-empty {\n  font-size: 13px;\n  opacity: 0.4;\n  padding: 8px 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.gw-embed-container {\n  margin-top: 16px;\n  border-radius: 8px;\n  overflow: hidden;\n  min-height: 300px;\n}\n\n.gw-embed-content {\n  width: 100%;\n  min-height: 300px;\n}\n\n.gw-embed-loading,\n.gw-embed-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px;\n  font-size: 13px;\n  opacity: 0.6;\n}\n\n// ==================== AUDIO TAB ====================\n\n.mic-select-field {\n  width: 100%;\n  max-width: 400px;\n}\n\n.audio-no-devices {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.audio-hint {\n  font-size: 12px;\n  opacity: 0.5;\n  margin: 0;\n}\n\n.mic-test-area {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.mic-test-meter {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.mic-test-level-bar {\n  flex: 1;\n  max-width: 300px;\n  height: 8px;\n  background: var(--card-bg, rgba(255, 255, 255, 0.05));\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.mic-test-level-fill {\n  height: 100%;\n  background: #4caf50;\n  border-radius: 4px;\n  transition: width 50ms ease-out;\n}\n\n.mic-test-level-label {\n  font-size: 12px;\n  opacity: 0.6;\n  min-width: 35px;\n}\n\n.mic-test-transcript {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px;\n  background: var(--card-bg, rgba(255, 255, 255, 0.05));\n  border-radius: 8px;\n  min-height: 40px;\n  max-width: 500px;\n  font-size: 13px;\n\n  .transcript-icon {\n    font-size: 18px;\n    opacity: 0.5;\n    flex-shrink: 0;\n    margin-top: 1px;\n  }\n\n  .transcript-placeholder {\n    opacity: 0.4;\n    font-style: italic;\n  }\n}\n\n.mic-test-error {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #f44336;\n  font-size: 13px;\n\n  mat-icon {\n    font-size: 18px;\n  }\n}\n\n.mic-test-diagnostics {\n  margin-top: 8px;\n  background: rgba(244, 67, 54, 0.08);\n  border: 1px solid rgba(244, 67, 54, 0.25);\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-size: 12px;\n\n  pre {\n    margin: 0;\n    white-space: pre-wrap;\n    word-break: break-word;\n    color: rgba(255, 255, 255, 0.8);\n    font-family: 'JetBrains Mono', 'Fira Code', monospace;\n    font-size: 11px;\n    line-height: 1.5;\n    max-height: 200px;\n    overflow-y: auto;\n    user-select: all;\n  }\n\n  .copy-diagnostics-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    margin-top: 8px;\n    padding: 4px 10px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 4px;\n    background: rgba(255, 255, 255, 0.06);\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 11px;\n    cursor: pointer;\n    transition: background 0.15s;\n\n    mat-icon {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n    }\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.12);\n      color: rgba(255, 255, 255, 0.9);\n    }\n  }\n}\n\n// ==================== TEAMS TAB ====================\n\n.team-create-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n\n  .team-name-field {\n    flex: 1;\n  }\n\n  button {\n    margin-top: 4px;\n    min-width: 80px;\n  }\n}\n\n.team-error {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #f44336;\n  font-size: 0.8125rem;\n  margin-top: -0.5rem;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.teams-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 0;\n  opacity: 0.7;\n  font-size: 0.875rem;\n}\n\n.teams-empty {\n  padding: 1.5rem 0;\n  opacity: 0.5;\n  font-size: 0.875rem;\n}\n\n.team-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.team-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.625rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba(128, 128, 128, 0.15);\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background: rgba(128, 128, 128, 0.06);\n  }\n\n  &.active {\n    border-color: var(--primary-color, #2aa198);\n    background: rgba(var(--primary-rgb, 42, 161, 152), 0.06);\n  }\n\n  .team-card-info {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .team-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 6px;\n    background: var(--primary-color, #2aa198);\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 0.875rem;\n    flex-shrink: 0;\n  }\n\n  .team-card-details {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  .team-card-name {\n    font-weight: 500;\n    font-size: 0.875rem;\n  }\n\n  .team-card-slug {\n    font-size: 0.75rem;\n    opacity: 0.5;\n  }\n\n  .team-card-actions {\n    display: flex;\n    gap: 0.25rem;\n    opacity: 0;\n    transition: opacity 0.15s ease;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  &:hover .team-card-actions {\n    opacity: 1;\n  }\n\n  .team-edit-field {\n    flex: 1;\n    margin: -0.5rem 0;\n  }\n}\n\n.moved-note { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; padding: 12px 14px; border: 1px dashed rgba(128,128,128,.4); border-radius: 8px; margin: 10px 0; opacity: .85;\n  mat-icon { opacity: .6; }\n}\n.moved-link { background: transparent; border: 1px solid rgba(97,175,239,.55); border-radius: 999px; color: #61afef; cursor: pointer; padding: 2px 12px; font: inherit; font-size: 12px;\n  &:hover { background: rgba(97,175,239,.12); } }\n\n.your-teams { border: 1px solid rgba(128,128,128,.3); border-radius: 8px; padding: 12px 14px; margin: 10px 0; }\n.your-teams-head { display: flex; align-items: center; gap: 8px; font-weight: 600; margin-bottom: 4px;\n  mat-icon { opacity: .6; } .kc-link { margin-left: auto; font-size: 12px; color: #61afef; text-decoration: none; } }\n.team-pill { display: inline-block; border: 1px solid rgba(97,175,239,.5); border-radius: 999px; padding: 2px 12px; margin: 2px 6px 2px 0; font-size: 12px; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
